


















































import { computed, defineComponent, reactive, SetupContext, watch } from "@vue/composition-api";
import { UAParser } from "ua-parser-js";

import { getters, mutations, store } from "../store";
import { formatBuild, formatSupportLink } from "../../service/format";

import Modal from "./Modal.vue";
import Button from "./Button.vue";
import TextInput from "./TextInput.vue";

// Both of these are defined in vue.config.js.
// VERSION reads from package.json and COMMIT_HASH is git rev-parse --short HEAD output
declare const VERSION: string;
declare const COMMIT_HASH: string;

interface Props {
    isOpen: boolean;
}

export default defineComponent({
    name: "ModalReportError",
    components: {
        Button,
        Modal,
        TextInput
    },
    model: {
        prop: "isOpen",
        event: "change"
    },
    props: { isOpen: Boolean },
    setup(props: Props, context: SetupContext) {
        const ua = new UAParser(navigator.userAgent);

        const account = computed(() => store.state.account.user != null ?
            store.state.account.user.session.account as import("@hashgraph/sdk").AccountId :
            null);

        const accountId = computed(() => {
            if (account.value != null) {
                const accountId: import("@hashgraph/sdk").AccountId = account.value;
                return (
                    `${accountId.shard
                    }.${
                        accountId.realm
                    }.${
                        accountId.account}`
                );
            }

            return null;
        });

        const platform = computed(() => {
            const name = ua.getOS().name;
            const version = ua.getOS().version;
            return formatBuild(name, version);
        });

        const browser = computed(() => {
            const name = ua.getBrowser().name;
            const version = ua.getBrowser().version;
            return formatBuild(name, version);
        });

        const url = computed(() => context.root.$route !== undefined ?
            context.root.$route.fullPath :
            null);

        const device = computed(() => {
            const type = ua.getDevice().type;
            const model = ua.getDevice().model;
            return formatBuild(type, model);
        });

        const state = reactive({
            platform: platform.value || "",
            browser: browser.value || "",
            url: url.value,
            description: "",
            device: device.value || "",
            version: `v${VERSION}+${COMMIT_HASH}`,
            accountId: accountId.value || "",
            details: ""
        });

        const errorMessage = computed(getters.errorMessage);

        const sendLink = computed(() => formatSupportLink(
            state.url,
            state.platform,
            state.browser,
            state.device,
            state.version,
            state.accountId,
            `${errorMessage.value}
                ${state.details}`
        ));

        function close(): void {
            context.emit("change", false);

            // Wait until the close animation to clear the form
            setTimeout(mutations.errorViewed, 150);
        }

        function handleCancel(): void {
            close();
        }

        function handleSend(): void {
            window.open(sendLink.value);
            close();
        }

        function handleInput(text: string): void {
            state.details = text;
        }

        // When the route is updated, reset the path value
        watch(
            () => context.root.$route,
            () => {
                if (context.root.$route === undefined) return null;
                state.url = context.root.$route.fullPath;
                return null;
            }
        );

        return {
            errorMessage,
            handleCancel,
            handleSend,
            handleInput
        };
    }
});
